import _ from 'lodash';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { getGlobalClasses } from '../../themes';
import FleetConfigContainer from '../../containers/FleetConfig';
import FormComponent from '../../components/FormComponent';

const DEPARTMENT_LABELS = {
	colton: 'Colton',
	sandiego: 'San Diego',
	paramount: 'Paramount',
	longbeach: 'Long Beach',
	portland: 'Portland',
	eugene: 'Eugene',
	phoenix: 'Phoenix',
	tacoma: 'Tacoma',
	ferndale: 'Ferndale',
	billing: 'Billing',
	safety: 'Safety',
	dispatch: 'Dispatch',
};

const DEPT_ORDER = [
	'colton',
	'sandiego',
	'paramount',
	'longbeach',
	'portland',
	'eugene',
	'phoenix',
	'tacoma',
	'ferndale',
	'billing',
	'safety',
	'dispatch',
];

const styles = (theme) => ({
	...getGlobalClasses(theme),
	sectionHeadline: {
		fontSize: 20,
		fontWeight: 600,
		marginTop: 32,
		marginBottom: 12,
		color: '#333',
	},
	tableCard: {
		marginBottom: 32,
		overflowX: 'auto',
	},
	headerCell: {
		fontWeight: 700,
		backgroundColor: '#f5f5f5',
		whiteSpace: 'nowrap',
	},
	tableRow: {
		'&:nth-child(even)': {
			backgroundColor: '#fafafa',
		},
	},
	cell: {
		whiteSpace: 'nowrap',
		padding: '8px 16px',
	},
	emptyCell: {
		whiteSpace: 'nowrap',
		padding: '8px 16px',
		color: '#bbb',
	},
	userId: {
		fontSize: '0.75rem',
		color: '#999',
		marginLeft: 6,
	},
});

function userName(userId, userMap) {
	if (!userId) return null;
	const user = userMap[userId];
	if (!user) return `User #${userId}`;
	return `${user.firstName} ${user.lastName}`;
}

function UserCell({ userId, userMap, classes }) {
	if (!userId) {
		return <TableCell className={classes.emptyCell}>—</TableCell>;
	}
	return (
		<TableCell className={classes.cell}>
			{userName(userId, userMap)}
			<span className={classes.userId}>#{userId}</span>
		</TableCell>
	);
}

class FleetConfig extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			fleetConfig: null,
		};
	}

	componentDidMount() {
		const { getFleetConfig, searchUsers, showErrors } = this.props;
		searchUsers();
		getFleetConfig({
			callback: (err, result) => {
				if (err) return showErrors(err);
				this.setState({ fleetConfig: result });
			},
		});
	}

	render() {
		const { classes, userMap } = this.props;
		const { fleetConfig } = this.state;

		const {
			fleetDepartmentToTerminalManagerUserId = {},
			fleetDepartmentToTerminalAdminUserId = {},
			fleetDepartmentToMechUserId = {},
			userIdToManagerUserId = {},
		} = fleetConfig || {};

		return (
			<Fragment>
				<div className={classes.globalMainHeadline}>Fleet Config</div>

				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography className={classes.sectionHeadline}>Department Assignments</Typography>
						<Paper className={classes.tableCard}>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell className={classes.headerCell}>Department</TableCell>
										<TableCell className={classes.headerCell}>Terminal Manager</TableCell>
										<TableCell className={classes.headerCell}>Terminal Admin</TableCell>
										<TableCell className={classes.headerCell}>Mechanic</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{DEPT_ORDER.map((dept) => (
										<TableRow key={dept} className={classes.tableRow}>
											<TableCell className={classes.cell}>
												{DEPARTMENT_LABELS[dept] || dept}
											</TableCell>
											<UserCell
												userId={fleetDepartmentToTerminalManagerUserId[dept]}
												userMap={userMap}
												classes={classes}
											/>
											<UserCell
												userId={fleetDepartmentToTerminalAdminUserId[dept]}
												userMap={userMap}
												classes={classes}
											/>
											<UserCell
												userId={fleetDepartmentToMechUserId[dept]}
												userMap={userMap}
												classes={classes}
											/>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Paper>

						<Typography className={classes.sectionHeadline}>Manager Assignments</Typography>
						<Paper className={classes.tableCard}>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell className={classes.headerCell}>User</TableCell>
										<TableCell className={classes.headerCell}>Reports To</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{Object.entries(userIdToManagerUserId).map(([userId, managerId]) => (
										<TableRow key={userId} className={classes.tableRow}>
											<TableCell className={classes.cell}>
												{userName(Number(userId), userMap)}
												<span className={classes.userId}>#{userId}</span>
											</TableCell>
											<UserCell userId={managerId} userMap={userMap} classes={classes} />
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Paper>
					</Grid>
				</Grid>
			</Fragment>
		);
	}
}

FleetConfig.propTypes = {
	classes: PropTypes.object.isRequired,
	userMap: PropTypes.object.isRequired,
	getFleetConfig: PropTypes.func.isRequired,
	searchUsers: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), FleetConfigContainer])(FleetConfig);
